<template>
  <div class="video-player">
    <loadscript v-if="!isFlowApiLoaded" @loaded="initFlow"
      :src="'//cdn.flowplayer.com/players/' + flowid + '/native/flowplayer.async.js'" />
    <div class="player" data-player-id="5fad92db-6cc6-4995-946b-4c139aac736b" />
  </div>
</template>
 
<script>
import loadscript from '@Foundation/loadscript/loadscript';
 
export default {
  name: 'video-main',
  components: { loadscript },
  props: {
    video: {
      type: String,
      default: null
    },
    flowid: {
      type: String,
      default: null
    },
    videoTag: {
      type: Object,
      default: {}
    }
  },
 
  data() {
    return {
      flowPlayer: null,
      isFlowApiLoaded: false
    };
  },
 
  mounted() {
    this.checkFlowApi();
 
    if (this.isFlowApiLoaded) {
      this.initFlow();
    }
 
    window.addEventListener('popstate', this.forcePageReload, false);
  },
 
  destroyed() {
    window.removeEventListener('popstate', this.forcePageReload, false);
  },
 
  methods: {
    forcePageReload() {
      location.reload();
    },
 
    checkFlowApi() {
      this.isFlowApiLoaded = this.$root.rootState.flowApiExist;
    },
 
    initFlow() {
      !this.isFlowApiLoaded && this.$root.setRootData('flowApiExist', true);
      if (this.$el) {
        const containerEl = this.$el.querySelector('.player');
        flowplayer.cloud.then(() => {
          this.flowPlayer = flowplayer(containerEl, {
            src: this.video
          });
          if (this.flowPlayer) {
            this.flowPlayer.on('pause', () => {
              this.triggerDataLayerEvents('pause');
            });
            this.flowPlayer.on('playing', () =>  {
              this.triggerDataLayerEvents('play');
            });
          }
        });
      }
    },
    triggerDataLayerEvents(action) {
      this.videoTag.video_title = decodeURI(this.videoTag.video_title);
      const videoTagClone = {
        ...this.videoTag,
        video_action: action
      };
      videoTagClone.video_action = action;
      window.dataLayer.push(videoTagClone);
    }
  }
};
</script>
